/* tslint:disable */
/* eslint-disable */
/**
 * crm-screener-api
 * crm-screener-api
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RecipientProviderStatus } from './RecipientProviderStatus';
import {
    RecipientProviderStatusFromJSON,
    RecipientProviderStatusFromJSONTyped,
    RecipientProviderStatusToJSON,
    RecipientProviderStatusToJSONTyped,
} from './RecipientProviderStatus';

/**
 * 
 * @export
 * @interface AllowedRecipientFacility
 */
export interface AllowedRecipientFacility {
    /**
     * 
     */
    id: number;
    /**
     * 
     */
    name: string;
    /**
     * 
     */
    facility_type: string;
    /**
     * 
     */
    address: string;
    /**
     * 
     */
    organization_id: number;
    /**
     * 
     */
    provider_id?: string;
    /**
     * 
     */
    email?: string;
    /**
     * Optional branded label overriding the generic facility-type label in the recipient picker (e.g. "Dialyze Direct").
     */
    display_name?: string;
    /**
     * 
     */
    provider_status?: RecipientProviderStatus;
    /**
     * 
     */
    ccn?: string;
}



/**
 * Check if a given object implements the AllowedRecipientFacility interface.
 */
export function instanceOfAllowedRecipientFacility(value: object): value is AllowedRecipientFacility {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('facility_type' in value) || value['facility_type'] === undefined) return false;
    if (!('address' in value) || value['address'] === undefined) return false;
    if (!('organization_id' in value) || value['organization_id'] === undefined) return false;
    return true;
}

export function AllowedRecipientFacilityFromJSON(json: any): AllowedRecipientFacility {
    return AllowedRecipientFacilityFromJSONTyped(json, false);
}

export function AllowedRecipientFacilityFromJSONTyped(json: any, ignoreDiscriminator: boolean): AllowedRecipientFacility {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'facility_type': json['facility_type'],
        'address': json['address'],
        'organization_id': json['organization_id'],
        'provider_id': json['provider_id'] == null ? undefined : json['provider_id'],
        'email': json['email'] == null ? undefined : json['email'],
        'display_name': json['display_name'] == null ? undefined : json['display_name'],
        'provider_status': json['provider_status'] == null ? undefined : RecipientProviderStatusFromJSON(json['provider_status']),
        'ccn': json['ccn'] == null ? undefined : json['ccn'],
    };
}

export function AllowedRecipientFacilityToJSON(json: any): AllowedRecipientFacility {
    return AllowedRecipientFacilityToJSONTyped(json, false);
}

export function AllowedRecipientFacilityToJSONTyped(value?: AllowedRecipientFacility | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'facility_type': value['facility_type'],
        'address': value['address'],
        'organization_id': value['organization_id'],
        'provider_id': value['provider_id'],
        'email': value['email'],
        'display_name': value['display_name'],
        'provider_status': RecipientProviderStatusToJSON(value['provider_status']),
        'ccn': value['ccn'],
    };
}

